import type { StoreApi } from 'zustand'

import type { ToastActions, ToastItem, ToastStore } from './types'
import { shouldScheduleToastDismiss } from './utils/shouldScheduleToastDismiss'

type SetState = StoreApi<ToastStore>['setState']
type GetState = StoreApi<ToastStore>['getState']

const generateToastId = (): string => `toast-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`

export const createToastActions = (set: SetState, get: GetState): ToastActions => ({
  showToast: (toast) => {
    const id = generateToastId()
    const newToast: ToastItem = {
      id,
      variant: 'success',
      position: 'bottom-right',
      ...toast,
    }

    set((state) => ({ toasts: [...state.toasts, newToast] }))

    if (shouldScheduleToastDismiss(newToast.duration)) {
      setTimeout(() => get().removeToast(id), newToast.duration)
    }

    return id
  },

  removeToast: (id) => {
    set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) }))
  },
})
